/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { HappinessMeter } from 'aurora-section-components';
import classNames from 'classnames';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import { CleverTapGenericServiceSubmitSuccessScreenEvent } from 'aurora-utils/cleverTap.eventhelper';
import { keyEmptyCheck, isFeedbackProvided } from 'aurora-utils/utils';
import Box from '@material-ui/core/Box';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import { ADGMImage } from 'aurora-components';
import { useClipboard } from 'aurora-hooks';
import styles from './styles';

function Layout(props) {
  const {
    classes,
    history,
    type,
    title,
    subTitle,
    data,
    downloadhandler,
    isShowPdfButton,
    isShowCourtOrder,
    courtOrderTerminationhandler,
    downloadPaymenthandler,
  } = props;
  const [propertyObject, setPropertyObject] = useState('');
  const lang = localStorage.getItem('lang');
  useEffect(() => {
    if (lang === 'en') {
      setPropertyObject(data?.en);
    } else {
      setPropertyObject(data?.ar);
    }
    CleverTapGenericServiceSubmitSuccessScreenEvent({
      screenName: `screen_${data?.en?.application?.applicationDetails?.applicationType}_success_submit_view`,
      applicationStatus: data?.en?.application?.applicationDetails?.applicationStatus,
      applicationId: data?.en?.application?.applicationDetails?.applicationId,
      applicationNumber: data?.en?.application?.applicationDetails?.applicationNumber,
      applicationType: data?.en?.application?.applicationDetails?.applicationType,
    });
  }, [data]);
  const goToApplicationHandler = () => {
    history.push('/app/applications?type=applications');
  };
  const renderIcon = typeIcon => {
    if (typeIcon === 'rejection') {
      return 'discardIconV2.svg';
    }
    if (typeIcon === 'termination') {
      return 'errorIconV2.svg';
    }

    return 'successIconV2.svg';
  };
  const renderClass = typeClass => {
    if (typeClass === 'rejection') {
      return classes.headerTitleReject;
    }
    if (typeClass === 'termination') {
      return classes.headerTitleTerminate;
    }

    return classes.headerTitleSuccess;
  };

  const { copy } = useClipboard();

  const isFeedbackGiven = isFeedbackProvided(
    data?.en?.application?.applicationDetails?.initiatorUserId,
    data?.en?.application?.applicationDetails?.happinessMeter,
    data?.en?.application?.applicationDetails?.applicationStatus,
  );
  const showSubTitle = useMemo(() => {
    return propertyObject?.showSubTitle;
  }, [propertyObject]);
  return (
    <Container className={classes.successScreenContainer}>
      {!isFeedbackGiven && (
        <HappinessMeter
          applicationNumber={data?.en?.application?.applicationDetails?.applicationNumber}
          applicationId={data?.en?.application?.applicationDetails?.applicationId}
          applicationType={data?.en?.application?.applicationDetails?.applicationType}
        />
      )}
      <div className={classes.successScreenHeader}>
        {/* <Hidden smDown> */}
        <ADGMImage className={classes.successScreenHeaderImg} name={renderIcon(type)} alt='status img' />
        {/* </Hidden> */}
        <div className={classes.successScreenHeaderContent}>
          <Typography
            variant='h6'
            component='h1'
            className={`${classes.successScreenHeaderTitle} ${renderClass(type)}`}
          >
            {title}
          </Typography>

          {subTitle && showSubTitle && (
            <Typography className={classes.successScreenHeaderSubTitle} variant='body1'>
              {subTitle}
            </Typography>
          )}

          <Grid container spacing={2} className={classes.mt20} direction='column' alignItems='center'>
            {isShowPdfButton === true && (
              <Grid container spacing={2} className={classes.mt20} direction='column' alignItems='center'>
                <Button variant='body1' className={classes.successScreenHeaderDownloadButton} onClick={downloadhandler}>
                  <ADGMImage name='Download-contract-black.svg' alt='Icon' />
                  <FormattedMessage {...messages.Download_contract} />
                </Button>
              </Grid>
            )}
            {typeof downloadPaymenthandler === 'function' && (
              <Grid container spacing={2} className={classes.mt20} direction='column' alignItems='center'>
                <Button
                  variant='body1'
                  className={classes.successScreenHeaderDownloadButton}
                  onClick={downloadPaymenthandler}
                >
                  <ADGMImage name='Download-contract-black.svg' alt='Icon' />
                  <FormattedMessage {...messages.download_payment_receipt} />
                </Button>
              </Grid>
            )}
            {isShowCourtOrder && isShowCourtOrder === true ? (
              <>
                <Grid container spacing={2} className={classes.mt20} direction='column' alignItems='center'>
                  <Button
                    variant='body1'
                    className={classes.successScreenHeaderDownloadButton}
                    onClick={courtOrderTerminationhandler}
                  >
                    <ADGMImage name='Download-contract-black.svg' alt='Icon' />{' '}
                    <FormattedMessage {...messages.terminate_by_court_order} />
                  </Button>
                </Grid>
              </>
            ) : (
              ''
            )}
          </Grid>
        </div>
      </div>
      {propertyObject?.applicationNumber && (
        <>
          <Hidden mdUp>
            <div className={classNames(classes.detailItemHorizontal, classes.applicationNumberContainer)}>
              <Typography className={classes.applicationNumber}>
                {keyEmptyCheck('Application_ID')}:&nbsp;
                <span className={classes.applicationNumberBold}>{propertyObject?.applicationNumber}</span>
                <span className={classes.applicationNumberIcon}>
                  <ADGMImage
                    name='ApplicationIDIconDark.svg'
                    alt='copyIcon'
                    onClick={() => copy(propertyObject?.applicationNumber)}
                  />
                </span>
              </Typography>
            </div>
          </Hidden>

          <div className={classes.successScreenMainContent}>
            <Box className={classes.successBoxContent} p={2}>
              {/* Application ID */}
              <Box>
                <ADGMItemDetails
                  label='Application_ID'
                  labelClass={classes.applicationNumberLabel}
                  value={
                    <Box sx={{ display: 'flex' }}>
                      <span>{propertyObject?.applicationNumber}</span>
                      <span className={classes.applicationNumberIconn}>
                        <ADGMImage
                          name='ApplicationIDIconDark.svg'
                          alt='copyIcon'
                          onClick={() => copy(propertyObject?.applicationNumber)}
                        />
                      </span>
                    </Box>
                  }
                />
              </Box>
            </Box>
          </div>
        </>
      )}
      <div className={classes.successScreenFooter}>
        <Button variant='contained' className={classes.successScreenFooterButton} onClick={goToApplicationHandler}>
          {keyEmptyCheck('go_to_applications')}
        </Button>
      </div>
    </Container>
  );
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  isShowPdfButton: PropTypes.bool.isRequired,
  isShowCourtOrder: PropTypes.bool.isRequired,
  downloadhandler: PropTypes.func.isRequired,
  courtOrderTerminationhandler: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  downloadPaymenthandler: PropTypes.func.isRequired,
};

export default withStyles(styles)(injectIntl(Layout));
